<template>
	 <div class="mainbody">
		
	  
	   <div class="custom-timeline" style="padding-bottom: 2vw;">
		 
		 <div 
		   v-for="(item, index) in items" 
		   :key="index" 
		   
		 >
		<!-- {{ item }} -->
		   <div style="display: flex;align-items: center;padding-bottom: 0.5vh;">
			<div   class="gkfzlccss0" v-scroll-animate="'fly-in-left5'">{{ item.dateSite }}</div>
			<div  class="menu4flex1"><img src="../../assets/w/img3/gaikuangNew/yuan-icon.png" /> </div>
			<!-- <div class="menu4flex2"><img src="../../img3/gaikuangNew/fazhan-icon.png" v-scroll-animate="'fly-in-right'" /></div> -->
			<div  class="gkfzlccss1" v-scroll-animate="'fly-in-right5'"><a> {{ item.synopsis }} </a></div>
		</div>
		 </div>
	   </div>
	</div>
	
  </template>
  
  <script>
     import API from '@/api/index'

  export default {
	data() {
	  return {
		items: [
		  {
			date: '2023-01-01',
			title: '项目启动',
			content: '项目正式启动，组建团队'
		  } 
		]
	  }
	},
	mounted(){
	this.getSynopsisFn()
   },
   methods:{
	   //  
	   async getSynopsisFn() {
		
			try {
				let objParams={
					catId:'d45c2e1b53704b97ba5fcf2067f7ed35',
					pageNum:1
				}
				const res = await API.getSynopsis(objParams)
				this.items=res.data.synopsisList
				console.log(res.data)
			} catch (error) {
			
			}
		},
   }
  }
  </script>
<style lang="scss" scoped>
   .mainbody{
  width: 100%;
  background:url('../../assets/w/img3/gaikuangNew/fzlcBg.png');
  background-size: 100% 100%;
  padding-top:0.2rem;
 }
  .custom-timeline {
	position: relative;
	width: 65%;
	margin: 0 auto;
	font-size: 0.8rem;
	@media screen and (max-width: 768px) {
		width: 100%;
    }
	  }
  
//   .custom-timeline::before {
// 	content: '';
// 	position: absolute;
// 	width: 2px;
// 	background-color: #e4e7ed;
// 	top: 0;
// 	bottom: 0;
// 	left: 50%;
// 	transform: translateX(-50%);
//   }
  
  .timeline-item {
	padding: 10px 40px;
	position: relative;
	width: 50%;
  }
  
  .timeline-item.left {
	left: 0;
  }
  
  .timeline-item.right {
	left: 50%;
  }
  
  .timeline-content {
	padding:5px 20px;
	position: relative;
  }
  
  .timeline-dot {
	position: absolute;
	width: 16px;
	height: 16px;
	background-color: #015293;
	border-radius: 50%;
	top: 50%;
	transform: translateY(-50%);
	z-index: 1;
	@media screen and (max-width: 768px) {
      top: 1%;
    }
  }
  
  .timeline-item.left .timeline-dot {
	right: -8px;
  }
  
  .timeline-item.right .timeline-dot {
	left: -8px;
  }
  
  .timeline-card {
	// background: #877da6;
	color: #f4f3f3e5;
	padding: 5px;
	border-radius: 6px;
	@media screen and (max-width: 768px) {
	 
	}
  }
   
  
  .timeline-date {
	color: #015293;
	font-weight: bold;
	margin-bottom: 10px;
  }
  
  .timeline-item.left .timeline-date {
	text-align: right;
  }
  
  .timeline-item.right .timeline-date {
	text-align: left;
  }
  
  @media screen and (max-width: 768px) {
	.custom-timeline::before {
	  left: 31px;
	}
	
	.timeline-item {
	  width: 100%;
	  padding-left: 70px;
	  padding-right: 25px;
	}
	
	.timeline-item.right {
	  left: 0;
	}
	
	.timeline-item.left .timeline-dot,
	.timeline-item.right .timeline-dot {
	  left: 23px;
	}
	
	.timeline-item.left .timeline-date,
	.timeline-item.right .timeline-date {
	  text-align: left;
	  font-size:12px
	}
  }
  </style>